import ErrorBlock from './ErrorBlock';
import { ErrorBlockCombinedProps, ErrorBlockProps, ErrorBlockValueProps } from './types';

export type { ErrorBlockCombinedProps, ErrorBlockProps, ErrorBlockValueProps };
export default ErrorBlock;
